import { z } from 'zod';
export const TariffSchema = z.object({
    id: z.string(),
    currency: z.string().default('TND'),
    pricePerH: z.number().int().min(0),
    minMinutes: z.number().int().min(15).default(15),
    maxMinutes: z.number().int().positive().optional(),
    freeMinutes: z.number().int().min(0).optional(),
    schedule: z.record(z.any()).optional(),
    updatedAt: z.date(),
});
